import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/蓝得智能logo@2x.png'


const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "logo-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "imgUrl",
    src: _imports_0
  })
], -1)
const _hoisted_4 = { class: "tabbar-container" }

import TabBar from "./components/TabBar.vue";
import { onMounted, onBeforeUnmount } from 'vue';
import autofit from 'autofit.js';

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

onMounted(() => {
  autofit.init({
        dh: 1080,
        dw: 1920,
        resize: true
    })


});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(TabBar)
      ])
    ]),
    _createVNode(_component_router_view)
  ]))
}
}

})